import { action, observable } from 'mobx'
import { AgreementDTO, Page } from 'models'
import { GENERAL_STORE } from 'store/GeneralStore'
import { PaginationSearchBase } from 'store/PaginationSearchBase'
import { RootStore } from 'store/RootStore'
import { Api, FilterRange } from 'utilities'
import {
  AgreementFilterDTO, agreementsTableNeedTimeoutProps,
  AgreementsTableSearchProps, AgreementsTableSortProps,
  initialAgreementsTablePaginationProps,
  initialAgreementsTableSearchProps
} from './AgreementsTableStore.types'

export const AGREEMENTS_TABLE_STORE = 'AGREEMENTS_TABLE_STORE'

export class AgreementsTableStore extends PaginationSearchBase<
  AgreementsTableSortProps,
  AgreementsTableSearchProps,
  AgreementDTO
  > {
  private _rootStore: RootStore

  constructor (rootStore: RootStore) {
    super(
      initialAgreementsTablePaginationProps,
      initialAgreementsTableSearchProps,
      [],
      agreementsTableNeedTimeoutProps
    )
    this._rootStore = rootStore
  }

  @observable budgetRange: FilterRange = { min: null, max: null }

  @action setBudgetRange = (range: FilterRange) => {
    // Remaining budget range is recalculated by BE every time new filters are applied
    // and new search is triggered. Only the first response with no filters from BE is needed here.
    // So we need to ignore all range updates after the first.
    if (this.budgetRange.min !== null && this.budgetRange.max !== null) return
    this.budgetRange = range
  }

  triggerSearch = () => {
    const {
      setLoadingOn,
      setLoadingOff,
      handleApiError
    } = this._rootStore[GENERAL_STORE]

    setLoadingOn()

    const filter: AgreementFilterDTO = {
      ...this.searchProps,
      agreementStart: this.searchProps.agreementStart
        // ? '2020-08-01T09:38:47.166Z'
        ? this.searchProps.agreementStart.format()
        // ? this.searchProps.agreementStart.format('YYYY-MM-DD')
        : null,
      agreementEnd: this.searchProps.agreementEnd
        // ? '2020-08-31T09:38:47.166Z'
        ? this.searchProps.agreementEnd.format()
        // ? this.searchProps.agreementEnd.format('YYYY-MM-DD')
        : null
    }
    const {
      page,
      size,
      sortProp,
      sortDirection
    } = this.pagination

    Api
      .post(
        `/agreement/all?page=${page
        }&size=${size
        }&sort=${sortProp},${sortDirection}`,
        filter
      )
      .then((data: Page<AgreementDTO>) => {
        this.setBudgetRange({ min: data.min, max: data.max })
        this.setSearchResults(data.content)
        this.setPaginationProps(data)
        setLoadingOff()
      })
      .catch(handleApiError)
  }
}
